export default __webpack_public_path__ + "static/media/pagefour.0a21d120.txt";